import axios from 'axios';
import { resolveId } from '../../utils';
import { getRoutesQuery, getProcessorsQuery, getHaulingCompaniesQuery, getProducersQuery, getUserGroupQuery, getCommoditiesQuery } from './queries';
import { buildExpressQuery, buildLoopbackQuery } from './queries/builders';
import { getUserDisplayName, getUserLicenseNumber } from '../helpers/users/utils';
import Split from '../split';

const getScheduleConfig2Details = async (region) => {
    try {
        const queryBuilder = Split.getBooleanTreatment('use_express_auth_endpoints') ? buildExpressQuery : buildLoopbackQuery;
        const migrationQueryBuilder = Split.getBooleanTreatment('use_express_migration_endpoints') ? buildExpressQuery : buildLoopbackQuery;
        const haulerFields = ['id', 'name', 'hauler_number'];
        const fields = ['id', 'name', 'license_number'];
        const filterDeleted = true;

        const routeQuery = getRoutesQuery({ filterDeleted, queryBuilder: migrationQueryBuilder });
        const processorQuery = getProcessorsQuery({ fields, filterDeleted, queryBuilder });
        const haulingQuery = getHaulingCompaniesQuery({ fields: haulerFields, filterDeleted, queryBuilder });
        const populate = { users: ['role', 'name', 'deleted_at'] };
        const userGroupQuery = getUserGroupQuery({ populate });
        const producerQuery = getProducersQuery({ fields, filterDeleted, queryBuilder });
        const commoditiesQuery = getCommoditiesQuery();

        const routeRequest = axios.get(routeQuery);
        const processorRequest = axios.get(processorQuery);
        const haulingRequest = axios.get(haulingQuery);
        const producerRequest = axios.get(producerQuery);
        const userGroupRequest = axios.get(userGroupQuery);
        const commoditiesRequest = axios.get(commoditiesQuery);

        const [routeResponse, processorResponse, haulingResponse, producerResponse, userGroupResponse, commoditiesResponse] = await Promise.all([routeRequest, processorRequest, haulingRequest, producerRequest, userGroupRequest, commoditiesRequest]);
        const userGroups = userGroupResponse.data.map((userGroup) => resolveId(userGroup)).sort((a, b) => (a.name < b.name ? -1 : 1));
        const processors = Array.isArray(processorResponse.data) ? processorResponse.data.map(resolveId) : [];
        const haulingCompanies = Array.isArray(haulingResponse.data) ? haulingResponse.data.map(resolveId) : [];
        const producers = Array.isArray(producerResponse.data) ? producerResponse.data.map(resolveId) : [];

        const processorGroups = userGroups.map((group) => {
            const user_ids = [];
            group.users.forEach((user) => {
                const resolvedUser = resolveId(user);
                if (user.role === 'processor' && resolvedUser.id) user_ids.push(resolvedUser.id);
            });
            const newGroup = { ...group, user_ids, role: 'processor' };
            delete newGroup.users;
            return newGroup;
        });
        const haulingGroups = userGroups.map((group) => {
            const user_ids = [];
            group.users.forEach((user) => {
                const resolvedUser = resolveId(user);
                if (user.role === 'transport' && resolvedUser.id) user_ids.push(resolvedUser.id);
            });
            const newGroup = { ...group, user_ids, role: 'transport' };
            delete newGroup.users;
            return newGroup;
        });

        const processorOptions = processors.map((p) => {
            const license_number = getUserLicenseNumber(p);
            const name = getUserDisplayName(p.name, license_number, false);
            return { ...p, name };
        });

        const haulingOptions = haulingCompanies.map((h) => {
            const license_number = getUserLicenseNumber(h);
            const name = getUserDisplayName(h.name, license_number, false);
            return { ...h, name };
        });

        const commodities = commoditiesResponse.data.map((c) => {
            return { id: c.type, name: c.name };
        });

        return {
            routes: Array.isArray(routeResponse.data) ? routeResponse.data.map(resolveId) : [],
            processors: processorOptions,
            haulingCompanies: haulingOptions,
            producers,
            processorGroups,
            haulingGroups,
            commodities,
        };
    } catch (err) {
        // eslint-disable-next-line
        console.log(err);
        throw new Error('Unable to process request.');
    }
};

export default getScheduleConfig2Details;
